import { makeAutoObservable } from 'mobx';
import { Cart, CartLine } from '@common/merch';

type LoadingOperation = 'add' | 'remove' | 'update';

export class CartStore {
  public cart?: Cart = undefined;
  public currency = 'USD';
  public isLoading = false;
  public loadingLineId?: string = undefined;
  public loadingOperation?: LoadingOperation = undefined;

  constructor() {
    const storedCurrency = localStorage.getItem('merch_currency');
    if (storedCurrency) {
      this.currency = storedCurrency;
    }
    makeAutoObservable(this);
  }

  public get isEmpty(): boolean {
    return !this.cart || this.cart.lines.length === 0;
  }

  public get items(): CartLine[] {
    return this.cart?.lines || [];
  }

  // Total number of units across all lines (for the nav cart badge).
  public get totalQuantity(): number {
    return this.items.reduce((sum, line) => sum + (line.quantity || 0), 0);
  }

  public get total(): number {
    if (!this.cart) return 0;
    return parseFloat(this.cart.cost.totalAmount.amount);
  }

  public get subtotal(): number {
    if (!this.cart) return 0;
    return parseFloat(this.cart.cost.subtotalAmount.amount);
  }

  public get checkoutUrl(): string | undefined {
    return this.cart?.checkoutUrl;
  }

  public setCart(cart: Cart): void {
    this.cart = { ...cart };
    if (cart.cost.totalAmount.currencyCode) {
      this.currency = cart.cost.totalAmount.currencyCode;
      localStorage.setItem('merch_currency', this.currency);
    }
  }

  public clearCart(): void {
    this.cart = undefined;
  }

  public setLoading(isLoading: boolean, lineId?: string, operation?: LoadingOperation): void {
    this.isLoading = isLoading;
    this.loadingLineId = lineId;
    this.loadingOperation = operation;
  }
}
